// @ts-strict-ignore
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { LocaleResourceManager } from '@shared/manager/locale-resource.manager';
import { ArticleVO } from '../../../model/vo/article.vo';
import { CustomValidators } from '@shared/custom-validators';
import { AlertHelper } from '@shared/alert/alert.helper';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ArticleAccessoryEntryVO } from '../../../model/vo/article-accessory-info-vo';
import { ArticleDataService } from '../../../service/article-data.service';

@Component({
  standalone: false,
  selector: 'app-add-accessory',
  templateUrl: './add-accessory.component.html',
})
export class AddAccessoryComponent implements OnInit {
  @Output() public finish = new EventEmitter<ArticleAccessoryEntryVO>();

  private readonly NUMBER_RESTRICTER: string = '^[0-9]*$';

  public form: FormGroup;
  public inputValueRestricter = this.NUMBER_RESTRICTER;

  constructor(
    private bsModalRef: BsModalRef,
    private fb: FormBuilder,
    private alertHelper: AlertHelper,
    private localeResourceManager: LocaleResourceManager,
    private articleDataService: ArticleDataService
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      source: new FormControl('', CustomValidators.trimRequired),
      rotationDelta: new FormControl('', [CustomValidators.required, CustomValidators.integer]),
    });
  }

  public close(): void {
    this.bsModalRef.hide();
  }

  public save(): void {
    const accessoryArticleSource: string = this.form.controls.source.value;

    this.articleDataService.loadArticleByIdOrArticleNumberAndVersion(accessoryArticleSource).subscribe((article: ArticleVO) => {
      if (!article) {
        this.alertHelper.showError('searchArticleView.title.no_articles_found', 'searchArticleView.message.no_articles_found', {
          translationParams: [accessoryArticleSource],
        });
        this.form.controls.source.setErrors({});
      } else {
        const articleDTO: ArticleAccessoryEntryVO = {
          accessoryArticleId: article.identity,
          accessoryArticleNumber: article.articleNo,
          rotationDelta: +this.form.controls.rotationDelta.value,
        };
        this.finish.emit(articleDTO);
        this.close();
      }
    });
  }

  public getInputError(c: AbstractControl): string {
    if (c && c.hasError('messageKey')) {
      return this.localeResourceManager.getValueByKey(c.getError('messageKey'), { 0: c.getError('param') });
    } else {
      return '';
    }
  }
}
